import React, { createContext, useContext, useState,useEffect } from "react";
import { sendMessage, uploadFiles, checkUrlStatus, InvokeMatrixApi,upload_FilesOnly } from "./WorkspaceUtils";
import ImageFormat from "../components/workspace/settingBar/ImageSettings/ImageFormat";
import sourceUrl from "../api/Source.api";
import axios from "axios";

const WorkspaceContext = createContext();
export const useWorkspace = () => useContext(WorkspaceContext);

const WorkspaceProvider = ({ children }) => {
  // threadHistory
  const [threads, setThreads] = useState([]);
  // [{ sender: enum("modalX", "user"), content: content, file(optional):{url: url, urlStatus: enum("processing", "processed")} }, ...]
  const [currentThread, setCurrentThread] = useState([]);
  // boolean to check if the thread is waiting for a response
  const [waitThread, setWaitThread] = useState(false);
  // threadSettings {synthesiaSettings: {}, synthesiaAvatar: {}, synthesiaVoice: {}}
  const [threadSettings, setThreadSettings] = useState({});
  // [{ type:enum("link", "file"), name: string, file(if type file): File, link(if type link):weblink, status: enum("uploading", "uploaded", "upload failed"), fileId: string }, ...]
  const [threadFiles, setThreadFiles] = useState([]);
  // "string" Current thread ID for sending messages
  const [threadId, setThreadId] = useState(null);
  const [currentHistoryId,setCurrentHistoryId] = useState(null);

  // Image Settings starts==============================
  const [imageFormat,setImageFormat] = useState('png');
  const [imageModel,setImageModel] = useState('3d-model');
  const [imageRatio,setImageRatio] = useState('1:1');
  // Image settings ends =================================

  // ====================Video settings starts ============================
  const [videoAvatar,setVideoAvatar] = useState(null)
  const [videoBackground,setVideoBackground] = useState(null);
  const [videoVoice,setVideoVoice] = useState(null) ;
  const [videoLogo,setVideoLogo] = useState(null);
  const [videoAvatarLanguage,setVideoAvatarLanguage] = useState(null);
  // ====================Video settings ends ============================

  // ==================== Audio settings starts ============================
  const [audioLanguage,setAudioLanguage] = useState(null);
  const [audioVoice,setAudioVoice] = useState(null);
  // ==================== Audio settings ends ==============================

  const [sending,setSending]  = useState(false);

  const [templateId, setTemplateId] = useState(1);

  const [historyFiles,setHistoryFiles] = useState([]);

  const [Today,setToday] = useState([]);
  const [Yesterday,setYesterday] = useState([]);
  const [ThisWeek,setThisWeek] = useState([]);
  const [ThisMonth,setThisMonth] = useState([]);
  const [PrevMonth,setPrevMonth] = useState([]);

  const [showLeftsideBar,setShowLeftsideBar] = useState(true);
  const [showRightsideBar,setShowRightsideBar] = useState(true);

  const [showFirstVisitModal, setShowFirstVisitModal] = useState(false);
  const [showVideoSettings,setShowVideoSettings] = useState(false);
  const [showImageSettings,setShowImageSettings] = useState(false);
  const [showPptSettings,setShowPptSettings] = useState(false);
  const [showAudioSettings,setShowAudioSettings] = useState(false);

  // useEffect(() => {
  //   // Check if the user has already visited
  //   const hasVisited = localStorage.getItem("hasVisitedWorkspace");

  //   if (!hasVisited) {
  //     // If not, show the modal
  //     setShowFirstVisitModal(true);
  //     // Mark as visited
  //     localStorage.setItem("hasVisitedWorkspace", "true");
  //   }
  // }, []);

  useEffect(() => {
    const fetchOnboardingStatus = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${sourceUrl}/user/onboardingStatus`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'User-Agent': 'Mozilla/5.0',
          },
        });

        const { status } = response.data.data;

        // Update modal and hasVisitedWorkspace based on status
        if (status) {
          setShowFirstVisitModal(true); // If status is true, show video settings modal
        }
        localStorage.setItem("hasVisitedWorkspace", status ? "true" : "false");
      } catch (error) {
        console.error("Error fetching onboarding status:", error);
      }
    };

    fetchOnboardingStatus();
  }, []);


  const clearThread = () => {
    // Clear current thread
    setCurrentThread([]);
    // clear thread id
    setThreadId(null);
    // clear thread settings
    setThreadSettings({});
    // clear thread files
    setThreadFiles([]);
    // clear history files
    setHistoryFiles([]);
    // clear current history id
    setCurrentHistoryId(null);
  };
  

  const value = {
    threads,
    setThreads,
    currentThread,
    setCurrentThread,
    threadSettings,
    setThreadSettings,
    threadFiles,
    setThreadFiles,
    threadId,
    setThreadId,
    currentHistoryId,
    setCurrentHistoryId,
    waitThread,
    setWaitThread,
    clearThread,
    templateId,
    setTemplateId,
    sending,
    setSending,
    historyFiles,
    setHistoryFiles,
    Today,
    setToday,
    Yesterday,
    setYesterday,
    ThisWeek,
    setThisWeek,
    ThisMonth,
    setThisMonth,
    PrevMonth,
    setPrevMonth,
    showLeftsideBar,
    setShowLeftsideBar,
    showRightsideBar,
    setShowRightsideBar,
    imageFormat,
    setImageFormat,
    imageModel,
    setImageModel,
    imageRatio,
    setImageRatio,
    videoAvatar,
    setVideoAvatar,
    videoBackground,
    setVideoBackground,
    videoVoice,
    setVideoVoice,
    videoAvatarLanguage,
    setVideoAvatarLanguage,
    audioLanguage,
    setAudioLanguage,
    audioVoice,
    setAudioVoice,
    showFirstVisitModal,
    setShowFirstVisitModal,
    showVideoSettings,
    setShowVideoSettings,
    showImageSettings,
    setShowImageSettings,
    showPptSettings,
    setShowPptSettings,
    showAudioSettings,
    setShowAudioSettings,
    sendMessage: async (latestEntry,isValidDetails) =>
      await sendMessage(
        latestEntry,
        threadId,
        threadFiles,
        threadSettings,
        setThreadId,
        templateId,
        historyFiles,
        imageFormat,
        imageModel,
        imageRatio,
        videoAvatar,
        videoBackground,
        videoVoice,
        videoAvatarLanguage,
        audioLanguage,
        audioVoice,
        isValidDetails
      ),
    uploadFiles: async (fileObj) =>
      await uploadFiles(fileObj, threadId, setThreadId),
    upload_FilesOnly: async (fileObj) =>
      await upload_FilesOnly(fileObj, threadId, setThreadId),
    checkUrlStatus: async (url) => await checkUrlStatus(url, threadId),
    InvokeMatrixApi: async (jsonRespData,respData,reqType,endPoint,reqBody) => 
     await InvokeMatrixApi(
      jsonRespData,
      respData,
      reqType,
      threadId,
      endPoint,
      reqBody,
      setThreadId
     )
  };
  
  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export default WorkspaceProvider;
